import { Component, OnInit } from '@angular/core';
import { CustomersService } from 'src/app/_services/customers.service';

@Component({
  selector: 'app-customer-notification-permission',
  templateUrl: './customer-notification-permission.component.html',
  styleUrls: ['./customer-notification-permission.component.scss']
})
export class CustomerNotificationPermissionComponent implements OnInit {

  constructor(
    public _customerService: CustomersService
  ) { }

  ngOnInit(): void {
  }

}
